module.exports = __webpack_public_path__ + "static/media/applause.586ed45b.mp3";